<template>
  <Portal to="popup-modal">
    <div name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-body">
              <slot name="body" />
            </div>
            <div class="modal-footer">
              <slot name="footer" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Portal>
</template>

<script>
export default {
  name: "Modal",
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: table;
  transition: opacity 0.3s ease;
  overflow-y: auto;
  background-color: #000000db;
}
.modal-wrapper {
  position: fixed;
  top: calc(100vh - 85%);
  width: 100%;
}
.modal-container {
  background-color: #fff;
  transition: all 0.3s ease;
  overflow-y: auto;
  margin: 20px;
  border-radius: 5px;
  opacity: 1;
}
.modal-body {
  min-height: 100px;
  text-align: center;
  padding: 20px;
}
.modal-footer {
  margin: 10px;
}
/*size  >768px */
@media only screen and (min-width: 769px) {
  .modal-mask {
    transition: opacity 0.3s ease;
    background-color: rgba(0, 0, 0, 0.5);
    top: 0px;
  }

  .modal-container {
    width: 500px;
    height: fit-content;
    max-height: calc(100vh - 100px);
    margin: 0px auto;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
  }
  @media only screen and (min-width: 769px) {
    .modal-footer {
      margin: 10px 30px;
    }
  }
}
</style>
